"use strict";
(function () {
  if (!customElements.get("pb-message-popup")) {
    class PbMessagePopup extends HTMLElement {
      constructor() {
        super();
        this.phoneInput;
        this.closeModal = this.closeModal.bind(this);
        this.onOverlayClick = this.onOverlayClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onInit = this.onInit.bind(this);
        this.setupCurrentStep = false;
      }

      connectedCallback() {
        this.setupElements();
        this.addEventListeners();
        this.onInit();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }
    }

    PbMessagePopup.prototype.setupElements = function () {
      this.phoneInput = this.querySelector('input[type="tel"]');
      this.modal = this.querySelector('[data-component="modal"]');
      this.imagePicker = document.getElementById("images-picker");
      this.builder = document.querySelector("portrait-builder");
      this.overlay = this.querySelector('[data-component="overlay"]');
      this.close = this.querySelector('[data-component="close"]');
      this.nextBtn = document.querySelector(
        'builder-step-btn[data-type="next"]',
      );
      this.form = this.querySelector("form");

      // Ensure buttons are focusable
      if (this.close) this.close.setAttribute("tabindex", "0");
      if (this.nextBtn) this.nextBtn.setAttribute("tabindex", "0");
      if (this.overlay) this.overlay.setAttribute("tabindex", "0");
    };

    PbMessagePopup.prototype.addEventListeners = function () {
      if (this.overlay) {
        this.overlay.addEventListener("click", this.onOverlayClick);
      }
      if (this.close) {
        this.close.addEventListener("click", this.onOverlayClick);
        this.close.addEventListener("keydown", this.onKeyDown); // Handle keydown on close button
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener("keydown", this.onKeyDown); // Handle keydown on next button
      }

      window.addEventListener("load", this.onInit);
    };

    PbMessagePopup.prototype.removeEventListeners = function () {
      if (this.overlay) {
        this.overlay.removeEventListener("click", this.onOverlayClick);
      }
      if (this.close) {
        this.close.removeEventListener("click", this.onOverlayClick);
        this.close.removeEventListener("keydown", this.onKeyDown);
      }
      if (this.nextBtn) {
        this.nextBtn.removeEventListener("keydown", this.onKeyDown);
      }
      window.removeEventListener("load", this.onInit);
    };

    PbMessagePopup.prototype.onOverlayClick = function () {
      this.closeModal();
    };

    PbMessagePopup.prototype.onKeyDown = function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault(); // Prevent default action for Enter/Space
        if (e.target === this.close) {
          this.closeModal(); // Close the modal when pressing Enter/Space on the close button
        } else if (e.target === this.nextBtn) {
          this.closeModal(); // You can define any action for Next button if needed
        }
      }

      // Trap focus inside the modal when open
      if (this.modal.open) {
        const focusableElements = this.modal.querySelectorAll(
          'button, input, [tabindex]:not([tabindex="-1"])',
        );
        const firstFocusableElement = focusableElements[0];
        const lastFocusableElement =
          focusableElements[focusableElements.length - 1];

        // If Tab key is pressed, move focus forward
        if (e.key === "Tab") {
          if (document.activeElement === lastFocusableElement) {
            e.preventDefault();
            firstFocusableElement.focus(); // Focus first element if the Tab key is pressed at the end
          } else if (
            document.activeElement === firstFocusableElement &&
            e.shiftKey
          ) {
            e.preventDefault();
            lastFocusableElement.focus(); // Focus last element if Shift + Tab is pressed at the start
          }
        }
      }
    };

    PbMessagePopup.prototype.showModal = function () {
      if (!this.modal) return;

      this.defineType();

      const showModal = sessionStorage.getItem("pb-message-popup");
      if (showModal == "true") return;
      this.modal.showModal();
      sessionStorage.setItem("pb-message-popup", "true");
    };

    PbMessagePopup.prototype.closeModal = function () {
      if (!this.modal) return;
      this.modal.close();
    };

    PbMessagePopup.prototype.onInit = function () {
      if (
        this.form
          ?.querySelector(".pb-message-popup__form-inner")
          ?.classList?.contains("success")
      ) {
        if (this.nextBtn) {
          this.nextBtn.classList.remove("not-allowed");
        }
        if (this.builder) {
          this.builder.setState();
          setTimeout(async () => {
            this.setupCurrentStep = true;
            await new Promise((res) => {
              this.builder.setState();
              res();
            });
            this.builder.setActiveStep(2);
            const url = new URL(window.location.href);
            url.searchParams.delete("contact_posted"); // Remove contact_posted parameter
            url.hash = ""; // Clear the hash (#contact_form)
            history.replaceState({}, "", url); // Update
          }, 4000);
        }
      }
    };

    PbMessagePopup.prototype.defineType = function () {
      if (!this.imagePicker) return;
      if (this.imagePicker?.files?.length > 0) {
        this.classList.add("pb-message-popup--uploaded");
      }
    };

    customElements.define("pb-message-popup", PbMessagePopup);
  }
})();
